import {
	createResource,
	type RouterContext,
	type RouteResource,
} from '@atlassian/react-resource-router';
import type { RoutingSetupInProgressData } from './getRoutingSetupInProgressData.tsx';
import type { RoutingOnboardingFinishedData } from './getOnboardingFinishedData.tsx';
import type { ConnectTeamsGlobalGroupItem } from './getConnectTeamsGlobalGroupsData.tsx';

export const ROUTING_SETUP_STATUS_RESOURCE = 'ROUTING_SETUP_STATUS';
export const ROUTING_ONBOARDING_FINISHED_RESOURCE = 'ROUTING_ONBOARDING_FINISHED';
export const CONNECT_TEAMS_GLOBAL_GROUPS_RESOURCE = 'CONNECT_TEAMS_GLOBAL_GROUPS_WFO';

const getKey = ({ match }: RouterContext): string =>
	typeof match.params.projectKey === 'string' ? match.params.projectKey : '';

export const routingSetupStatusResource: RouteResource<RoutingSetupInProgressData> =
	createResource<RoutingSetupInProgressData>({
		type: ROUTING_SETUP_STATUS_RESOURCE,
		getKey,
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-resource-routing-setup-status", jiraSpaEntry: "async-resource-routing-setup-status" */ './getRoutingSetupInProgressData.tsx'
			),
		maxAge: 0,
	});

export const routingOnboardingFinishedResource: RouteResource<RoutingOnboardingFinishedData> =
	createResource<RoutingOnboardingFinishedData>({
		type: ROUTING_ONBOARDING_FINISHED_RESOURCE,
		getKey,
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-resource-routing-onboarding-finished", jiraSpaEntry: "async-resource-routing-onboarding-finished" */ './getOnboardingFinishedData.tsx'
			),
		maxAge: 0,
	});

export const connectTeamsGlobalGroupsResource: RouteResource<ConnectTeamsGlobalGroupItem[]> =
	createResource<ConnectTeamsGlobalGroupItem[]>({
		type: CONNECT_TEAMS_GLOBAL_GROUPS_RESOURCE,
		getKey,
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-resource-connect-teams-global-groups", jiraSpaEntry: "async-resource-connect-teams-global-groups" */ './getConnectTeamsGlobalGroupsData.tsx'
			),
		maxAge: 0,
	});
